import React from 'react'

import ForYou from 'app/PelatihanMandiriPage/pages/ForYou'
import PageHeader from 'app/PelatihanMandiriPage/components/PageHeader'
import { shouldHideNav } from 'app/PelatihanMandiriPage/helper'
import { WithLayoutListener } from 'components/Layout/Desktop/DesktopLayout'

// get from local storage
const BelajarMandiriIndex = (props) => {
  const { isDesktopScreenSize } = props

  return (
    <WithLayoutListener isDesktop={isDesktopScreenSize}>
      <ForYou isDesktop={isDesktopScreenSize} />
    </WithLayoutListener>
  )
}

BelajarMandiriIndex.layoutOpts = {
  hasHeader: !shouldHideNav(),
  className: 'text-default bg-gray-10',
  header: PageHeader,
  enableDesktopLayout: true,
}

export default BelajarMandiriIndex
